export default "__VITE_ASSET__DbmRh5Xg__"